<template>
  <div class="app d-flex flex-column">
    <div class="body align-self-center d-flex flex-column justify-content-center align-items-center">
        <div class="logo-container">
          <div v-html="svg.logo" class="signin-logo mb-4"></div>
        </div>
        <b-card no-body class="p-4 mb-0 input-card d-flex flex-column align-items-stretch">
          <b-card-body>
            <div>
              <div class="language-select"><Language /></div>
              <h4>{{ $t('AUTH.RESET_PASSWORD') }}</h4>
              <p>{{ $t('AUTH.NEW_PASSWORD') }}</p>
              <b-input-group class="mb-3">
                <div class="input-group-prepend"><span class="input-group-text"><i class="fa fa-user"></i></span></div>
                <input  type="password"
                        class="form-control"
                        :class="{'is-invalid': $v.resetPassword.$error, 'is-valid': !$v.resetPassword.$invalid}"
                        :placeholder="$t('AUTH.NEW_PASSWORD')"
                        v-model="resetPassword"
                        @blur="$v.resetPassword.$touch()">
                <b-form-invalid-feedback v-if="!$v.resetPassword.minLength">{{ $t('AUTH.INVALID_PASSWORD', { 'MINIMUM': $v.resetPassword.$params.minLength.min }) }}</b-form-invalid-feedback>
              </b-input-group>
              <p>{{ $t('AUTH.CONFIRM_PASSWORD') }}</p>
              <b-input-group class="mb-3">
                <div class="input-group-prepend"><span class="input-group-text"><i class="fa fa-user"></i></span></div>
                <input  type="password"
                        class="form-control"
                        :class="{'is-invalid': $v.confirmResetPassword.$error, 'is-valid': !$v.confirmResetPassword.$invalid}"
                        :placeholder="$t('AUTH.CONFIRM_PASSWORD')"
                        v-model="confirmResetPassword"
                        @blur="$v.confirmResetPassword.$touch()">
                <b-form-invalid-feedback v-if="!$v.confirmResetPassword.sameAsPassword">{{ $t('AUTH.IDENTICAL_PASSWORD') }}</b-form-invalid-feedback>
              </b-input-group>
              <b-row>
                <b-col cols="12" class="text-center">
                  <b-button variant="secondary" class="login-btn" :disabled="$v.$invalid" @click="changePassword">{{ $t('AUTH.RESET_PASSWORD') }}</b-button>
                </b-col>
              </b-row>
              <b-row class="action-btn-container">
                <b-col cols="12" class="text-center">
                  <b-button variant="link" class="px-0 mt-2" @click="loginClicked"><h5>{{ $t('AUTH.LOGIN') }}</h5></b-button>
                </b-col>
              </b-row>
            </div>
          </b-card-body>
        </b-card>
      </div>
    <Footer />
  </div>
</template>


<script>
import Vue from 'vue'
import { required, sameAs, minLength } from 'vuelidate/lib/validators'
import svg from '../../_svg.js'
import Language from '../../components/Header/Language'
import Footer from '../../components/Footer'
export default {
  name: 'ResetPassword',
  data () {
    return {
      resetPassword: '',
      confirmResetPassword: '',
      svg: svg
    }
  },
  components: {
    Footer,
    Language
  },
  computed: {
    currentYear () {
      return new Date().getFullYear()
    }
  },
  methods: {
    loginClicked: function () {
      console.log(this.$t('COMMON.MSG_EXPIRED'))
    },
    changePassword: function () {
      var token = this.$route.params.token.replace(/%0D/g, '')
      var data = new window.FormData()
      data.append('token', token)
      data.append('id', this.$route.params.id)
      data.append('password', this.resetPassword)
      Vue.axios.post('/forgot_password/reset_password', data)
        .then(response => {
          if (response.data.status === 'success') {
            Vue.toasted.show(this.$t('AUTH.PASSWORD_UPDATED'), { icon: 'chain-broken', type: 'success' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else if (response.data.status === 'expired') {
            Vue.toasted.show(this.$t('AUTH.LINK_EXPIRED'), { icon: 'chain-broken', type: 'error' })
          } else {
            Vue.toasted.show(this.$t('AUTH.LINK_USED'), { icon: 'chain-broken', type: 'error' })
          }
        }, error => {
          Vue.toasted.show(this.$t('ERROR.COMMON'), { icon: 'chain-broken', type: 'error' })
          console.log(error)
        })
    }
  },
  validations: {
    resetPassword: {
      required,
      minLength: minLength(6)
    },
    confirmResetPassword: {
      required,
      sameAsPassword: sameAs('resetPassword')
    }
  },
  mounted () {
    window.addEventListener('keyup', this.loginOnEnter)
  },
  destroyed () {
    window.removeEventListener('keyup', this.loginOnEnter)
  }
}
</script>

<style scoped>
.app {
  color: #0e2547;
}

.body {
  flex: 1 0 auto;
}

.label {
  font-size: 0.8rem;
}

.card input::placeholder {
  font-size: 0.7rem;
}

.card input:focus {
  outline: none;
}

.logo-container img {
  display: block;
}

.input-card {
  min-width: 30vw;
}

.input-container {
  border: 1px solid #d1d4d7;
  border-radius: 2px;
}

.input-card h4 {
  text-align: center;
}


.login-btn {
  border-radius: 15px;
  padding: 0.375rem 5.5rem;
  font-size: 1rem;
}

.language-select {
  margin-left: 90%;
  margin-bottom: -10%;
}

li {
  list-style-type: none;
}

@media screen and (max-width: 1000px) {
  .input-card {
    min-width: 70vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/auth/ResetPassword.vue